module.exports = __webpack_public_path__ + "static/img/preview-06.aa52ccdc.webp";